import { Button,  SaveIcon} from "melco-ui";
import { useTranslation } from "react-i18next";
import {    useConfirm } from "melco-shared-logic";
import { useFormikContext } from "formik";



type EditProfileConfirmButtonProps = {

};

export const EditProfileConfirmButton: React.FC<
    EditProfileConfirmButtonProps
> = () => {
    const { t } = useTranslation();
    const { submitForm, values } = useFormikContext();

    const confirmGenerate = useConfirm(
        async () => {

            submitForm();


        },
        {
            translationPrefix: [
                "users.actions",
                "update",
            ].join("."),



        }
    );





    return (

        <>
            <Button
                icon={<SaveIcon />}
                type="primary"

                onClick={(values) => {

                    confirmGenerate();

                }}
            >
                {t("users.actions.update.button")}
            </Button></>
    );
};
